import { SESSION_SCREEN, SessionEventEnum, SessionScreenEnum } from 'utils/events';

import { session } from './session';

const eventNavMap: Partial<Record<SessionEventEnum, typeof SESSION_SCREEN[keyof typeof SessionScreenEnum]>> = {
  [SessionEventEnum.QUOTE_RECEIVED]: SESSION_SCREEN.REVIEW_QUOTE,
  [SessionEventEnum.QUOTE_ACCEPTED]: SESSION_SCREEN.CUSTOMER_AND_VEHICLE_INFO,
  [SessionEventEnum.QUOTE_REJECTED]: SESSION_SCREEN.REQUEST_QUOTE,
  [SessionEventEnum.QUOTE_BOOKED]: SESSION_SCREEN.SDK_SUMMARY,
  [SessionEventEnum.CUSTOMER_AND_VEHICLE_INFO]: SESSION_SCREEN.PICKUP_INFO,
  [SessionEventEnum.PICKUP_INFO]: SESSION_SCREEN.DELIVERY_INFO,
  [SessionEventEnum.DELIVERY_INFO]: SESSION_SCREEN.PAYMENT_INFO,
  [SessionEventEnum.ORDER_SUCCESS]: SESSION_SCREEN.ORDER_SUCCESS,
  [SessionEventEnum.PAYMENT_FAILURE]: SESSION_SCREEN.PAYMENT_INFO,
  [SessionEventEnum.ORDER_FAILURE]: SESSION_SCREEN.ORDER_FAILURE,
};

export const processNextUrl = (event: keyof typeof SessionScreenEnum) => {
  const sdkBrand = session.getSdk();
  const nextScreen = eventNavMap[event as SessionEventEnum];
  const gclid = session.getGclid();

  if (event === SessionEventEnum.QUOTE_RECEIVED as string && sdkBrand !== null) {
    document.location.href = `${window.origin}/sdk${sdkBrand ? `/${sdkBrand}` : ''}/quote`;
  } else if (
    (event === SessionEventEnum.QUOTE_REJECTED as string || event === SessionEventEnum.QUOTE_NEW as string)
  ) {
    if (sdkBrand === null) {
      document.location.href = `${window.origin}${gclid ? `?gclid=${gclid}` : ''}`;
    } else {
      document.location.href = `${window.origin}/sdk${sdkBrand ? `/${sdkBrand}` : ''}${gclid ? `?gclid=${gclid}` : ''}`;
    }
  } else if (event === SessionEventEnum.QUOTE_BOOKED as string && sdkBrand !== null) {
    document.location.href = `${window.origin}/sdk${sdkBrand ? `/${sdkBrand}` : ''}/summary`;
  } else if (nextScreen) {
    document.location.href = window.origin + nextScreen;
  }
};
